import React from "react";
import { Alert, Row, Spinner } from "reactstrap";

import { useUserSubmission } from "../../api/APIClient";
import { UserNameLabel } from "../../components/UserNameLabel";
import { Achievement } from "./Achievement";
import { Heatmap } from "./Heatmap";
import { Submissions } from "./Submissions";

interface Props {
  userId: string;
}

export const UserPage = (props: Props) => {
  const { userId } = props;
  const submissions = useUserSubmission(userId);

  if (!submissions) {
    return <Spinner style={{ width: "3rem", height: "3rem" }} />;
  }

  if (userId.length === 0 || submissions.length === 0) {
    return <Alert color="danger">User not found!</Alert>;
  }

  const actualUserId = submissions[0].user_id;

  return (
    <div>
      <Row className="my-2 border-bottom">
        <UserNameLabel userId={actualUserId} big showRating />
      </Row>
      <Achievement userId={userId} />
      <Row className="my-2 border-bottom" />
      <Heatmap submissions={submissions} />
      <Row className="my-2 border-bottom" />
      <Submissions userId={userId} />
    </div>
  );
};
